import React, { useEffect } from "react"
import { connect } from "react-redux";
import PropTypes from "prop-types";
import BottomLine from '../../Footer/BottomLine';
import i18n from "../../../i18n";
import * as rk from "../../../localization/resourceKeys";

const RightToCorrectPersonnel = ({ stateSelector, requestForm }) => {
  useEffect(() => {
    if (!stateSelector.currentStateResidence || !stateSelector.customerRelation) {
      window.location.replace("/");
    }
  });

  const openMyServeLink = () => {
    window.open(i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_MY_SERVE_LINK));
  };

  const selectedFlow = requestForm?.step?.selectedFlow;

  return <>
    <div className="text_details">
      <div>
        {selectedFlow === "check" && i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_TEXT_1)}
        {selectedFlow === "new" && i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NEW_REQUEST_TEXT_1)}
        <span
          style={{ color: "#007eb2", cursor: "pointer" }}
          onClick={openMyServeLink}
          data-testid="myServeLink"
        >
          {selectedFlow === "check" && i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_TEXT_2)}
          {selectedFlow === "new" && i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NEW_REQUEST_TEXT_2)}
        </span>
        {selectedFlow === "new" && i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NEW_REQUEST_TEXT_3)}
        <br />
        <br />
        <br />
        {i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_1)}
        <ul>
          <li>
            {i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_2)}
            <ul>
              <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_2_1)}</li>
              <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_2_2)}</li>
            </ul>
          </li>
          <li>
            {i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_3)}
            <ul>
              <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_3_1)}</li>
              <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_3_2)}</li>
              <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_3_3)}</li>
            </ul>
          </li>
          <li>
            {i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4)}
            <ul>
              <li>
                {i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4_1)}
                <ul>
                  <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4_1_1)}</li>
                  <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4_1_2)}</li>
                  <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4_1_3)}</li>
                </ul>
              </li>
              <li>
                {i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4_2)}
                <ul>
                  <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4_2_1)}</li>
                  <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4_2_2)}</li>
                  <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4_2_3)}</li>
                  <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4_2_4)}</li>
                </ul>
              </li>
              <li>{i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_NOTE_4_3)}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div className="u-mt-small">
        {selectedFlow === "check" && i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_TEXT_3)}
      </div>
    </div>
    <div className='request-footer-wrapper'>
      <BottomLine />
    </div>
  </>
}

RightToCorrectPersonnel.propTypes = {
  stateSelector: PropTypes.object,
  requestForm: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    stateSelector: state.stateSelector,
    requestForm: state.requestForm,
  };
};

export default connect(mapStateToProps)(RightToCorrectPersonnel);